import * as Yup from 'yup';

export default Yup.object().shape({
  ftx_key: Yup.string().required('key required'),
  ftx_secret: Yup.string().required('secret required'),
  ftx_subaccount: Yup.string().required('subaccount required'),
});
